module.exports = __webpack_public_path__ + "static/media/p_40_2.c9beaf1e.png";